import angular from 'angular';
import constants from 'app/constants';
import {
  bcpSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog
} from 'app/components/global';
import editOtherResourcesDialog from './dialog.editOtherResourcesDialog';
import controller from './other-resources.controller';
import directive from './other-resources.directive';


export default angular.module('app.components.advisory.bcp.otherResources', [
  alerts,
  bcpSharedModelService,
  confirmDialog,
  constants,
  editOtherResourcesDialog,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('bcpOtherResources', directive)
  .controller('OtherResourcesController', controller)
  .name;

console.log('app.components.advisory.bcp.otherResources created');
